var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Center, Spinner, Text } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { EasyAccessContainer } from "./easy-access";
import { OutdoorContainer } from "./outdoor";
import i18n from "@/main/i18n/config";
import { home_en } from "../../../main/i18n/en";
import { home_pt_br } from "../../../main/i18n/pt-br";
export var HomeContainer = function () {
    var _a, _b;
    var t = useTranslation("home").t;
    var _c = useContext(AuthContext), user = _c.user, talentWalletId = _c.talentWalletId, clientWallets = _c.clientWallets;
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var clientRockId = (_a = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _a === void 0 ? void 0 : _a.rockId;
    var hasPersonas = {
        isRocker: user === null || user === void 0 ? void 0 : user.email.includes("@rockcontent.com"),
        isTalent: !!talentWalletId,
        isClientEmployee: !!clientRockId,
    };
    useEffect(function () {
        i18n.addResourceBundle("en", "home", home_en);
        i18n.addResourceBundle("pt", "home", home_pt_br);
        setLoading(false);
    }, []);
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(Box, { px: "16", py: "8", maxW: "1366px", w: "100%", minH: "100%", alignSelf: "center" }, loading ? (React.createElement(Center, { w: "100%", h: "100%" },
            React.createElement(Spinner, null))) : (React.createElement("div", null,
            React.createElement(Text, { fontSize: "xl" },
                t("welcome"),
                ",",
                React.createElement("b", null,
                    ((_b = user === null || user === void 0 ? void 0 : user.entity) === null || _b === void 0 ? void 0 : _b.preferredName) || (user === null || user === void 0 ? void 0 : user.entity.name),
                    "!")),
            React.createElement(EasyAccessContainer, __assign({ user: user }, hasPersonas)),
            React.createElement(OutdoorContainer, __assign({}, hasPersonas)))))));
};
